import React from "react";
import { Share2, MessageSquare } from "lucide-react";

export function SocialConsent({ value, onChange }) {
  const opt = (v, label, on) => (
    <button type="button" data-testid={`social-consent-${v ? "yes" : "no"}`} onClick={() => onChange(v)}
      className={`flex-1 min-w-0 text-sm font-semibold px-3 py-3 rounded-xl border transition-colors ${value === v ? on : "bg-white border-slate-200 text-slate-600"}`}>{label}</button>
  );
  return (
    <div data-testid="social-consent" className={`bg-white rounded-3xl p-4 mt-4 border shadow-sm ${value === null || value === undefined ? "border-amber-200" : "border-slate-100"}`}>
      <div className="flex items-center gap-2 mb-1">
        <Share2 className="w-4 h-4 text-emerald-600" />
        <p className="text-sm font-bold text-slate-900">Rrjetet sociale të GjejShqip *</p>
      </div>
      <p className="text-xs text-slate-500 mb-3">A lejon që biznesi yt të shfaqet në rrjetet sociale të GjejShqip?</p>
      <div className="flex gap-2">
        {opt(true, "Lejohet", "bg-emerald-500 border-emerald-500 text-white")}
        {opt(false, "Nuk lejohet", "bg-rose-500 border-rose-500 text-white")}
      </div>
    </div>
  );
}

export const SOCIAL_MSG = "Zgjidh nëse lejohet biznesi yt në rrjetet sociale";

export function MessagesConsent({ value, onChange }) {
  const opt = (v, label, on) => (
    <button type="button" data-testid={`messages-consent-${v ? "yes" : "no"}`} onClick={() => onChange(v)}
      className={`flex-1 min-w-0 text-sm font-semibold px-3 py-3 rounded-xl border transition-colors ${value === v ? on : "bg-white border-slate-200 text-slate-600"}`}>{label}</button>
  );
  return (
    <div data-testid="messages-consent" className="bg-white rounded-3xl p-4 mt-4 border border-slate-100 shadow-sm">
      <div className="flex items-center gap-2 mb-1">
        <MessageSquare className="w-4 h-4 text-sky-500" />
        <p className="text-sm font-bold text-slate-900">Mesazhet (SMS) në GjejShqip</p>
      </div>
      <p className="text-xs text-slate-500 mb-3">A lejon që klientët të të shkruajnë mesazh në GjejShqip nga kjo reklamë?</p>
      <div className="flex gap-2">
        {opt(true, "Lejohet", "bg-emerald-500 border-emerald-500 text-white")}
        {opt(false, "Nuk lejohet", "bg-rose-500 border-rose-500 text-white")}
      </div>
    </div>
  );
}
